var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('HeaderMain'),_c('div',{staticClass:"page-content d-flex align-items-stretch"},[_c('div',{staticClass:"default-sidebar"},[_c('SideBar')],1),_c('div',{staticClass:"content-inner"},[_c('router-view',{attrs:{"name":"main"}}),_c('FooterMain')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }